import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Mixin from '@/helpers/mixin'
import VueRouter from 'vue-router'
import router from './router'
import store from './store'
import './assets/css/tokens.css'
// midnight content skin: dark canvas + bootstrap primitive re-inks, active
// only under [data-fi-theme="midnight"] (FI-1869 round 14)
import './assets/css/midnight.css'
import './custom.css'
import moment from 'moment-timezone'
import VueMeta from 'vue-meta'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'bootstrap/dist/css/bootstrap.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'font-awesome/css/font-awesome.css';
// FI-1432: shared markdown rendering variants, used by announcement
// detail, help article body, support ticket markdown, and anywhere
// else that displays user-facing markdown.
import './assets/css/markdown-variants.css';
import './assets/css/vsm-mobile.css';
import './assets/css/actuals-page.css';
import * as VueGoogleMaps from 'vue2-google-maps'
import { RichTextEditorPlugin, Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar } from "@syncfusion/ej2-vue-richtexteditor"
import PageVisibility from "@/helpers/pageVisibility";
import { registerLicense } from '@syncfusion/ej2-base';

// Registering Syncfusion license key
//registerLicense('Ngo9BigBOggjHTQxAR8/V1NCaF1cWWhBYVVpR2Nbe05xdl9HYlZQQmY/P1ZhSXxXdkJgWX5ccXZUQGNbVUA=');
registerLicense('Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXdecXVRR2ReU0d+XEU=')


Vue.config.productionTip = false

Vue.use(VueMeta)
Vue.mixin(Mixin)
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(RichTextEditorPlugin)
Vue.use(PageVisibility);

Vue.config.productionTip = false

Vue.filter('roundNumber', function(value,precision) {
    if (value) {
        return value.toFixed(precision).replace("0.",".")
    }
});

// `tz` is optional and overrides moment's global default for this call only — used by
// TBN report rows where each booking carries its own originating-yard tz (FI-1708)
Vue.filter('formatDateTime', function(value, tz) {
    if (value) {
        const m = moment(String(value))
        if (tz) m.tz(tz)
        return m.format('MM/DD/YY hh:mm:ss A')
    }
});

Vue.filter('formatDateTimeTZ', function(value, tz) {
    if (value) {
        const m = moment(String(value))
        if (tz) m.tz(tz)
        return m.format('MM/DD/YY hh:mm:ss A Z')
    }
});

Vue.filter('formatDateTimeSmall', function(value, tz) {
    if (value && typeof value === 'string') {
        const m = moment(String(value))
        if (tz) m.tz(tz)
        return m.format('MM/DD hh:mm A')
    }
});

Vue.filter('format24HrDateTimeSmall', function(value, is24HrEnabled, tz) {
    if (value && typeof value === 'string') {
        const m = moment(String(value))
        if (tz) m.tz(tz)
        if (is24HrEnabled) {
            return m.format('MM/DD HH:mm')
        } else {
            return m.format('MM/DD hh:mm A z')
        }
    }
});

Vue.filter('formatDateTimeCustom', function(value,format) {
    if (value && typeof value === 'string') {
      if (value.indexOf("T") != -1)
        return moment(String(value)).format(format)
      return moment(String(value),["MM/DD hh:mm A"]).format(format)
    }
});

Vue.filter('convert24HrDateTimeSmall', function(value,format) {
    if (value && typeof value === 'string') {
        if (format != "MM/DD hh:mm A") {
            return moment(value, ["MM/DD hh:mm A"]).format(format);
        } else {
            return value
        }
    }
});

Vue.filter('formatTimeSmall', function(value) {
    if (value) {
        return moment(String(value)).format('hh:mm A')
    }
});

Vue.filter('formatTimeXS', function(value) {
    if (value) {
        return moment(String(value)).format('hh:mm A')
    }
});

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
    }
});

Vue.filter('formatMinutes', function (value) {
  let totalMinutes = Math.floor(value);

  if (isNaN(totalMinutes)) {
    return '';
  }

  const isNegative = totalMinutes < 0;
  totalMinutes = Math.abs(totalMinutes);

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const parts = [];

  if (hours !== 0) parts.push(hours + 'h');
  if (minutes !== 0) parts.push(minutes + 'm');
  if (parts.length === 0) parts.push('0m');

  const formatted = parts.join(' ');
  return isNegative ? '-' + formatted : formatted;
});

Vue.filter('units', function(value,units) {
    if (value != null) {
        return value + units;
    }
});

Vue.filter("initCaps",  function(value,trim)  {
    if  (!value)  {
        return  "";
    }
    const words = String(value).split("-");
    let result = "";
    for (let word of words) {
        result += word.charAt(0).toUpperCase() + word.slice(1) + " ";
    }
    return result;
});

Vue.filter("prettyProperty",  function(value,trim)  {
    if  (!value)  {
        return  "";
    }
    const words = String(value).split("_");
    let result = "";
    for (let word of words) {
        result += word.charAt(0).toUpperCase() + word.slice(1) + " ";
    }
    return result.replace(trim,"").replace("Sms","SMS").replace("Sos","SOS").replace("Eld","ELD").replace("Dvir","DVIR").replace("Otp","OTP").replace("Tbn","TBN").replace("Hos","HOS");
});

Vue.filter("prettyPhoneNumber",  function(value)  {
    if  (!value)  {
        return  "";
    }
    value.replace("-","").replace("(","").replace(")","").replace(" ","")
    if (value.length == 11)
        return value.slice(1,4) + "-" + value.slice(4,7) + "-" + value.slice(7,11);
    else if (value.length == 10)
        return value.slice(0,3) + "-" + value.slice(3,6) + "-" + value.slice(6,10);
    return value;
});

Vue.filter('numberWithCommas', function(value) {
  if (typeof value !== 'number') {
    return value;
  }
  return value.toLocaleString();
});

Vue.filter("prettyJson", function(value) {
    return JSON.stringify(JSON.parse(value), null, 2);
});

Vue.filter("prettyJsonObj", function(value) {
    return JSON.stringify(value, null, 2);
});

Vue.filter("trim", function(value,num) {
    if (value != null)
        return value.split("").slice(0,num).join("");
});

Vue.filter("findbetween", function(value,num) {
    if (value != null)
        return value.split("(")[1].split(")")[0];
});

Vue.filter("fill", function(value,num) {
    if (value == null)
        return "".padStart(num,"-");
    return value;
});

Vue.filter("space", function(value,num) {
    if (value == null)
        return "".padStart(num,".");
    return value;
});

Vue.filter("nearest", function(value) {
    if (value != null)
        return value.replace("nearest","").replace("StartDateTime"," Time").replace("FinishDateTime"," Time")
});

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDO2Uu3jHZqAIgXw9jA0e0Wqi8q0-4C5Qs",
    libraries: 'places'
  }
})

Vue.use(datePicker);

// FI-1871: apply the per-user site theme before mount so first paint matches
// the user's choice (no flash). mirrored to localStorage on login and on
// change; default is "original" for everyone until they opt in.
try {
  const fiTheme = localStorage.getItem('fi_theme')
  const known = (fiTheme === 'new' || fiTheme === 'midnight') ? fiTheme : 'original'
  document.documentElement.setAttribute('data-fi-theme', known)
} catch (e) {
  document.documentElement.setAttribute('data-fi-theme', 'original')
}

new Vue({
  render: h => h(App),
    store,
    router
}).$mount('#app')

